import React, { Component } from "react";
import { Button, Modal, Image, Spinner } from "react-bootstrap";
import SideBar from "../components/SideBar_Com";
import Table from "../components/Table_Com";
import '../styles/Table_Style.css';
import { fetchKendaraan } from "../logics/FetchData_Logic";
import { deleteKendaraan } from "../logics/DeleteData_Logic";
import { AuthContext } from "../context/Auth_Context";
import Timeout from "./Timeout_Page";
import ModalLoading from "../components/ModalLoading_Com";

class TableKendaraan extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            showModalDelete: false,
            showModalPreview: false,
            delData: null,
            loading: false,
            successDel: null,
            url_gambar: "assets/user.svg",
            type: "",
            timeout: false,
            mainLoading: true
        }
    }

    preview = (obj, type) => {
        this.setState({
            showModalPreview: true,
            url_gambar: obj,
            type: type.toUpperCase()
        })
    }

    async componentDidMount() {
        const { auth, setToken } = this.context;
        let token = auth.token;
        let obj = await fetchKendaraan(token);
        let data_table = null;
        let timeout = false;
        if (obj[0] !== undefined) {
            if (obj[0].status === 402) {
                let path = "/";
                this.props.history.push({
                    pathname: path,
                    state: "Token anda telah expire akibat terlalu lama diam. Silahkan log-in lagi."
                })
            } else if (obj[0].status === 200) {
                data_table = {
                    data: obj[0].data.kendaraan,
                    searching: false,
                    scrollY: 341,
                    scrollCollapse: true,
                    columns: [
                        { data: "jenis" },
                        { data: "kapasitas" },
                        { data: "no_polisi" },
                        { 
                            data: "jenis_kendaraan",
                            render: (data)=>{
                                if(data === null) return "-"
                                return data
                            }
                        },
                        {
                            data: "tgl_exp",
                            render: function (data, type, row, meta) {
                                let date = new Date(data);
                                if (type === 'display' || type === 'filter') {
                                    if (data === "~") return data
                                    let year = date.getFullYear();
                                    let month = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
                                    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                                    return day + "-" + month + "-" + year;
                                }
                                if (data === '~') return 0;
                                else return date.getTime() / 1000;
                            }
                        },
                        { data: "idPengirim.nama" },
                        {
                            data: "path_uri_expire",
                            orderable: false,
                            render: function (data, type, row, meta) {
                                if (data === "~") return data;
                                return '<div class="icon_container"><img class="icon exp" key="' + data + '" src="assets/user.svg"/></div>';
                            }
                        },
                        {
                            data: "empty",
                            orderable: false,
                            className: "center",
                            defaultContent: '<div class="icon_container"><img class="icon edit" src="assets/edit.svg"/><img class="icon delete" src="assets/trash.svg"/></div>'
                        }
                    ],
                    columnDefs: [
                        {
                            targets: [0,2,3,5],
                            type: "text"
                        },
                        {
                            targets: 4,
                            type: "dates"
                        },
                        {
                            targets: 1,
                            type: "number"
                        }
                    ]
                }
                if (obj[0].token) setToken(obj[0].token);
            } else { //error?

            }
        } else if (obj[1].status && obj[1].status === 408) {
            timeout = true
        } else {
            this.props.history.push("/500ServerError")
        }
        this.setState({
            data: data_table,
            timeout: timeout,
            mainLoading: false
        })
    }

    confirmation = (data) => {
        let temp = new Object();
        Object.assign(temp,data)
        let date = new Date(temp.tgl_exp);
        let year = date.getFullYear();
        let month = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        temp.tgl_exp = day + "-" + month + "-" + year;
        this.setState({
            delData: temp,
            showModalDelete: true
        })
    }

    handleClose = () => {
        if (this.state.successDel) {
            window.location.reload();
        }
        else {
            this.setState({
                showModalDelete: false,
                showModalPreview: false
            })
        }
    }

    delete = async () => { // belum jalan
        this.setState({
            loading: true
        })
        const { auth, setToken } = this.context;
        let token = auth.token;
        let success = false;
        let response = await deleteKendaraan(token, this.state.delData._id, this.state.delData.jenis)
        if (response[0] !== undefined) {
            if (response[0].status === 200) {
                success = true;
                if (response[0].token) setToken(response[0].token);
            } else if (response[0].status === 402) {
                let path = "/";
                this.props.history.push({
                    pathname: path,
                    state: "Token anda telah expire akibat terlalu lama diam. Silahkan log-in lagi."
                })
            }
        }
        this.setState({
            loading: false,
            successDel: success
        })
    }

    render() {
        return (
            <div className="home">
                <Modal backdrop="static" show={this.state.showModalDelete} onHide={this.handleClose}>
                    <Modal.Header closeButton={!this.state.loading}>
                        <Modal.Title>Konfirmasi Hapus</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            this.state.successDel === null && this.state.delData ? (
                                <>
                                    <p>Apakah anda yakin untuk menghapus data berikut:</p>
                                    <ul>
                                        <li>Nama Kendaraan: {this.state.delData.jenis}</li>
                                        <li>Kapaistas: {this.state.delData.kapasitas + "(KL)"}</li>
                                        <li>No. Kendaaraan: {this.state.delData.no_polisi}</li>
                                        <li>Jenis Kendaraan: {this.state.delData.jenis_kendaraan}</li>
                                        <li>Tanggal Berlaku: {this.state.delData.tgl_exp}</li>
                                        <li>Perusahaan Pemilik: {this.state.delData.idPerusahaan.nama}</li>
                                    </ul>
                                </>
                            ) :
                                (
                                    this.state.successDel ?
                                        <p>Rekord berhasil dihapus</p>
                                        :
                                        <p>Error, terjadi kesalahan saat ingin menghapus rekord</p>
                                )
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        {
                            this.state.successDel !== null ?
                                <Button variant="secondary" onClick={this.handleClose}>
                                    Close
                                </Button>
                                : (this.state.loading ?
                                    <Button variant="danger" disabled>
                                        <Spinner animation="border" variant="secondary" />
                                    </Button>
                                    :
                                    <>
                                        <Button variant="secondary" onClick={this.handleClose}>
                                            Close
                            </Button>
                                        <Button variant="danger" onClick={this.delete}>
                                            Delete
                            </Button>
                                    </>)
                        }
                    </Modal.Footer>
                </Modal>
                <Modal backdrop="static" show={this.state.showModalPreview} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Preview {this.state.type}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Image src={this.state.url_gambar} thumbnail />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
                {!this.state.timeout && <SideBar />}
                <div className="main">
                    {this.state.mainLoading && <ModalLoading />}
                    {this.state.timeout && <Timeout {...this.props} />}
                    <div className="container-table">
                        {this.state.data && <Table  {...this.props} delete={this.confirmation} preview={this.preview} status={"TableKendaraan"} data={this.state.data} />}
                    </div>
                </div>
            </div>
        );
    }
}
TableKendaraan.contextType = AuthContext
export default TableKendaraan;